var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "separable" }, [
    _c(
      "div",
      { staticClass: "marginTop container" },
      [
        _c(
          "el-row",
          [
            _c(
              "el-col",
              { attrs: { span: 24 } },
              [
                _c("el-card", { staticClass: "card" }, [
                  _c("h4", { staticClass: "card-title" }, [
                    _vm._v("Resultado da pesquisa")
                  ]),
                  _c(
                    "div",
                    { staticClass: "card-body" },
                    [
                      _c("el-row", [_c("div", { staticClass: "divider" })]),
                      _c(
                        "div",
                        { staticClass: "table-pointer" },
                        [
                          _c(
                            "el-table",
                            {
                              staticStyle: { cursor: "pointer" },
                              attrs: {
                                data: _vm.cadastros,
                                "default-sort": {
                                  prop: "id",
                                  order: "descending"
                                }
                              },
                              on: { "sort-change": _vm.sort }
                            },
                            [
                              _c("el-table-column", {
                                attrs: { "min-width": "20" }
                              }),
                              this.tipo !== "PERIODO"
                                ? _c(
                                    "div",
                                    [
                                      this.tipo === "MUNICIPIOS"
                                        ? _c("el-table-column", {
                                            attrs: {
                                              label: "Municípios",
                                              "min-width": "200",
                                              prop: "label"
                                            }
                                          })
                                        : this.tipo === "ORDENS_SERVICO"
                                        ? _c("el-table-column", {
                                            attrs: {
                                              label: "Ordens de serviço",
                                              "min-width": "200",
                                              prop: "label"
                                            }
                                          })
                                        : _c("el-table-column", {
                                            attrs: {
                                              label: "Cadastrante",
                                              "min-width": "200",
                                              prop: "label"
                                            }
                                          }),
                                      _c("el-table-column", {
                                        attrs: {
                                          sortable: "sortable",
                                          label: "Quantidade",
                                          "min-width": "200",
                                          prop: "valor"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              this.tipo === "PERIODO" &&
                              this.tipoPeriodo === "DIARIO"
                                ? _c(
                                    "div",
                                    [
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "Período diário",
                                          "min-width": "125",
                                          prop: "label"
                                        }
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          sortable: "sortable",
                                          label: "Quantidade",
                                          "min-width": "125",
                                          prop: "valor"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              this.tipo === "PERIODO" &&
                              this.tipoPeriodo === "MENSAL"
                                ? _c(
                                    "div",
                                    [
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "Período mensal",
                                          "min-width": "125",
                                          prop: "label"
                                        }
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          sortable: "sortable",
                                          label: "Quantidade",
                                          "min-width": "125",
                                          prop: "valor"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              this.tipo === "PERIODO" &&
                              this.tipoPeriodo === "ANUAL"
                                ? _c(
                                    "div",
                                    [
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "Período anual",
                                          "min-width": "125",
                                          prop: "label"
                                        }
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          sortable: "sortable",
                                          label: "Quantidade",
                                          "min-width": "125",
                                          prop: "valor"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("div", { staticClass: "card-footer" }, [
                    _vm._v("Quantidade total: " + _vm._s(_vm.total))
                  ])
                ])
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0d1c279d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d1c279d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/relatorios_reurb/components/TabelaPrincipal.vue
// module id = null
// module chunks = 